module.exports = "<div class=\"thumbnail-container\">\n  <div class=\"thumbnail\" (click)=\"getImage(i)\"\n  *ngFor=\"let file of files; let i=index\">\n      <img alt=\"image {{i}}\" [src]=\"getImageUrl(file)\">\n  </div> \n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/gallery/gallery.component.html
// module id = ../../../../../src/app/shared/gallery/gallery.component.html
// module chunks = main